export default "__VITE_ASSET__C750yVM1__"